import React, { useState } from "react";
import { motion } from "framer-motion";

function Contact() {
  const mapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const usAddress = "34785 Pickford dr, Farmington Hills, MI 48335";
  const chennaiAddress = "Wimco Nagar, Chennai - 57";
  const chennaiMapQuery = "Wimco Nagar Metro Station, Chennai 600019";
  const bangaloreAddress = "Brigade Gardens, Church Street, Bengaluru";

  const locations = [
    { id: "us", label: "USA", address: usAddress },
    {
      id: "chennai",
      label: "Chennai",
      address: chennaiAddress,
      mapQuery: chennaiMapQuery,
    },
    { id: "bengaluru", label: "Bengaluru", address: bangaloreAddress },
  ];

  const [selectedLocationId, setSelectedLocationId] = useState("us");

  const buildMapSrc = (query) => {
    const encoded = encodeURIComponent(query);
    return mapsKey
      ? `https://www.google.com/maps/embed/v1/place?key=${mapsKey}&q=${encoded}`
      : `https://www.google.com/maps?q=${encoded}&output=embed`;
  };

  const selectedLocation = locations.find((l) => l.id === selectedLocationId);
  const mapSrc = buildMapSrc(
    selectedLocation.mapQuery || selectedLocation.address
  );
  return (
    <section id="contact" className="contact">
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Contact Info
      </motion.h2>
      <div className="contact-content">
        <motion.div
          className="contact-details"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h3>Get in Touch</h3>
          <div className="contact-info">
            <h4>Phone</h4>
            <p>+91 91761 22210</p>
            <h4>Email</h4>
            <p>info@quixentsolutions.com</p>
            <h4>Customer Support</h4>
            <p>
              Our support team is available around the clock to address any
              concerns or queries you may have.
            </p>
            <h4>Feedbacks & Suggestions</h4>
            <p>
              We value your feedback and suggestions. Your input is crucial in
              shaping the future of our company.
            </p>
            <h4>Addresses</h4>
            <div className="address-list">
              {locations.map((loc, idx) => (
                <div
                  key={loc.id}
                  className={`address-item${
                    selectedLocationId === loc.id ? " active" : ""
                  }`}
                  onClick={() => setSelectedLocationId(loc.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setSelectedLocationId(loc.id);
                  }}
                >
                  <div className="address-label">
                    {idx + 1}. {loc.label}
                  </div>
                  <div className="address-text">{loc.address}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="location-select">
            {locations.map((loc) => (
              <button
                key={loc.id}
                type="button"
                className={`location-button${
                  selectedLocationId === loc.id ? " active" : ""
                }`}
                onClick={() => setSelectedLocationId(loc.id)}
              >
                {loc.label}
              </button>
            ))}
          </div>
          <div className="map-container">
            <iframe
              title={`Quixent Solutions - ${selectedLocation.label}`}
              src={mapSrc}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            ></iframe>
          </div>
        </motion.div>
      </div>
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Enquiry
      </motion.h2>
      <div className="contact-content">
        <motion.form
          className="contact-form"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" required />
          <textarea placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </motion.form>
      </div>
    </section>
  );
}

export default Contact;
